import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader, SidebarRail } from "@base/ui";
import type { ComponentProps, ReactNode } from "react";
import { NavMain, type GrupoDeNavegacao } from "./nav-main";
import { NavUser, type UsuarioDaBarra } from "./nav-user";
import { rotuloDaVersaoRodando } from "./versao-rodando";

/**
 * Barra lateral do bloco `sidebar-07` do shadcn: recolhe para icones, seletor
 * de cliente no topo, navegacao no meio e a pessoa logada no rodape.
 */
export function AppSidebar({
  grupos,
  usuario,
  aoSair,
  aoAbrirPerfil,
  saindo,
  cabecalho,
  ...props
}: ComponentProps<typeof Sidebar> & {
  /** Topo da barra: o seletor de cliente (vem do modulo, nao do shared). */
  readonly cabecalho: ReactNode;
  readonly grupos: readonly GrupoDeNavegacao[];
  readonly usuario: UsuarioDaBarra;
  readonly aoSair: () => void;
  readonly saindo: boolean;
  readonly aoAbrirPerfil?: () => void;
}) {
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>{cabecalho}</SidebarHeader>
      <SidebarContent>
        <NavMain grupos={grupos} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser usuario={usuario} aoSair={aoSair} saindo={saindo} {...(aoAbrirPerfil ? { aoAbrirPerfil } : {})} />
        <p className="px-2 text-xs text-muted-foreground group-data-[collapsible=icon]:hidden">
          {rotuloDaVersaoRodando(__VERSAO__)}
        </p>
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
